import ReportDataTable from "./ReportDataTable";
import { ReportRow } from "../types";

const SupplierReport = ({ rows }: { rows: ReportRow[] }) => (
  <ReportDataTable rows={rows} emptyMessage="No supplier report data found." />
);

export default SupplierReport;
